/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Col_MatchInputs */

const en_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const de_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const fr_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const es_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const it_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const nl_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const pl_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const fi_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const da_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const sv_portal_scanner_col_match = /** @type {(inputs: Portal_Scanner_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

/**
* | output |
* | --- |
* | "Match" |
*
* @param {Portal_Scanner_Col_MatchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_col_match = /** @type {((inputs?: Portal_Scanner_Col_MatchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Col_MatchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_col_match(inputs)
	if (locale === "fr") return fr_portal_scanner_col_match(inputs)
	if (locale === "es") return es_portal_scanner_col_match(inputs)
	if (locale === "it") return it_portal_scanner_col_match(inputs)
	if (locale === "nl") return nl_portal_scanner_col_match(inputs)
	if (locale === "pl") return pl_portal_scanner_col_match(inputs)
	if (locale === "fi") return fi_portal_scanner_col_match(inputs)
	if (locale === "da") return da_portal_scanner_col_match(inputs)
	if (locale === "sv") return sv_portal_scanner_col_match(inputs)
	return en_portal_scanner_col_match(inputs)
});